export default function StepIndicator({ current, total }) {
  return (
    <div className="ec-steps">
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          className={`ec-step-dot ${
            i === current ? "ec-step-dot--active" : i < current ? "ec-step-dot--done" : "ec-step-dot--pending"
          }`}
        />
      ))}
    </div>
  );
}
